<aside class="app_navBar__container">
  <ul>
    <li class="item">
      <a
        (click)="onclick('examenes')"
        [ngClass]="{ 'router-link-active': rutaActual.includes('/examen') }"
      >
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <defs>
              <style>
                .b197c938-f348-487d-836c-bacf22e1e55d {
                  fill: none;
                }
                .a572234b-76d0-4696-aad0-f1f4597aa529 {
                  fill: #2c4352;
                }
              </style>
            </defs>
            <g id="f5ff1859-4c42-41fc-80e0-ca9774837944" data-name="Kit_2">
              <g
                id="a9fa1d93-0b32-4b10-bbeb-db7efb98ebd1"
                data-name="Grid_exams_icon"
              >
                <rect
                  class="b197c938-f348-487d-836c-bacf22e1e55d"
                  width="24"
                  height="24"
                />
                <g
                  id="e8f9d0d0-7c4f-4aa4-92e1-f2893d8727fd"
                  data-name="Contorneado"
                >
                  <path
                    class="a572234b-76d0-4696-aad0-f1f4597aa529"
                    d="M18.7,7.23,14.19,2.85A3,3,0,0,0,12.1,2H7.32a3,3,0,0,0-3,3v5.7a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V5a1,1,0,0,1,1-1h4.57V8a1.51,1.51,0,0,0,1.5,1.5h4.22V19a1,1,0,0,1-1,1H7.32a1,1,0,0,1-1-1v-.8a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1V19a3,3,0,0,0,3,3h9.29a3,3,0,0,0,3-3V9.38A3,3,0,0,0,18.7,7.23Zm-4.81.3V5.35l2.25,2.18Z"
                  />
                  <path
                    class="a572234b-76d0-4696-aad0-f1f4597aa529"
                    d="M9.31,17.47A1.05,1.05,0,0,1,8.42,17L7.31,15.19H5.07a.74.74,0,0,1-.75-.75h0a.75.75,0,0,1,.75-.75H7.56a1,1,0,0,1,.89.5l.75,1.19,1-2.92a1.07,1.07,0,0,1,.87-.7,1,1,0,0,1,1,.47L13,13.71h1.55a.76.76,0,0,1,.75.75h0a.76.76,0,0,1-.75.75h-1.8a1,1,0,0,1-.88-.48l-.58-.9-1,2.93a1,1,0,0,1-.88.7Zm3.84-3.55Z"
                  />
                </g>
              </g>
            </g>
          </svg>
        </span>
        <span>Exámenes</span>
      </a>
    </li>
    <li class="item">
      <a
        (click)="onclick('agendas')"
        [ngClass]="{ 'router-link-active': rutaActual.includes('/agendas') }"
      >
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <defs>
              <style>.f3418d97-1e17-4a50-9ff5-cf3dd73c3a02{fill:none;}.b8558c49-40b9-46c3-b6cb-bf12465a1b2c{fill:#555;}</style>
            </defs>
            <g id="a3d8ada6-a50b-4882-82e4-2e3dcb7585ea" data-name="Kit_4">
              <rect class="f3418d97-1e17-4a50-9ff5-cf3dd73c3a02" y="-0.01" width="24" height="24"/>
              <path class="b8558c49-40b9-46c3-b6cb-bf12465a1b2c" d="M18.58,4.15H17.14V3a1,1,0,1,0-2,0V4.15H8.87V3a1,1,0,0,0-2,0V4.15H5.25a2,2,0,0,0-2,2V18.48a2,2,0,0,0,2,2H18.58a2,2,0,0,0,2-2V6.15A2,2,0,0,0,18.58,4.15Zm0,14.33H5.25V10l13.33,0ZM5.25,8V6.15H6.87v.3a1,1,0,0,0,2,0v-.3h6.27v.3a1,1,0,0,0,2,0v-.3h1.44V8Z"/>
            </g>
          </svg>
        </span>
        <span>Agenda</span>
      </a>
    </li>
  </ul>
</aside>
